import './ProfileScene.scss';
export default function ProfileScene(props: any) {
    return (
        <div id="webAppScene" className="">
            <div id="app_scene_content">
                <div id="app-background" className="sc-hcmgZB frZtpH">
                </div>
                <main className="remove-main-padding" id="remove-main-padding_index" style={{ top: 0 }}>
                    <div data-gv2containerkey="settingsCta" className="fade-appear-done fade-enter-done">
                        {props.children}
                    </div>
                </main>
            </div>
        </div>
    );
}